import { SimulationSteps } from 'features/simulation/types'
import { CustomerFlows } from 'store/customer/enums'
import { store } from 'store'
import { goToStep, previousStep } from 'store/customer/slice'
import { RegistrationSteps } from 'features/registration/types'

export const handlePrevious = (flow: CustomerFlows, customPreviousStep?: SimulationSteps | RegistrationSteps) => {
  if (customPreviousStep) store.dispatch(goToStep({ flow, step: customPreviousStep }))
  else store.dispatch(previousStep({ flow }))
}
